export function form() {
  const forms = document.querySelectorAll('[data-form="user-signup"]');

  forms.forEach((formEl) => {
    const submitButton = formEl.querySelector('[data-id="user-submit"]');
    if (!submitButton) return;

    const updateSubmitState = () => {
      const isValid = formEl.checkValidity();
      submitButton.setAttribute("aria-disabled", isValid ? "false" : "true");
    };

    const handleInvalidSubmit = (event) => {
      if (submitButton.getAttribute("aria-disabled") === "true" || !formEl.checkValidity()) {
        event.preventDefault();
        formEl.reportValidity();
      }
    };

    formEl.addEventListener("input", updateSubmitState);
    formEl.addEventListener("change", updateSubmitState);
    formEl.addEventListener("submit", handleInvalidSubmit);
    submitButton.addEventListener("click", handleInvalidSubmit);

    updateSubmitState();
  });
}
